const FeaturesCard = ({ Icon, header, text, Link }) => {
  return (
    <div className="bg-[#F6F6F8] flex flex-col justify-start pt-20 items-center text-center w-[360px] h-[374px] p-8 rounded-lg space-y-4">
      <Icon />
      <h2 className="font-bold text-[20px]">{header}</h2>
      <p className="text-mainGray ">{text}</p>
      {Link}
    </div>
  );
};

export default FeaturesCard;
